export const AuditLogsMockData = [
  {
    id: '356f4fb1-b42c-ee11-b632-2c6dc19c19d5',
    timestamp: '2023-07-27T19:35:16.1964757+00:00',
    userId: '3c59cbfb-c68b-eb11-b566-000d3a2238b1',
    userDisplayName: 'Mock Audit Log User',
    type: 'Mock Audit Log Type',
    organizationId: '6c40c6c4-7405-4126-a60d-102f29fd2329',
    organizationDisplayName: 'Mock Audit Log Organization',
    relatedEntityId: '6fc728fa-8be4-eb11-b563-000d3a223e1c',
    relatedEntityTitle: 'mockuser@gmail.com',
    description: 'Mock Log Description',
  },
] as any[];
